import { Options } from "vue-property-decorator";
import { FormMixin } from "@/mixins/form/FormMixin";

@Options({})
export class GuestFormMixin extends FormMixin {
  public removeEventListeners(): void {
    return;
  }

  protected beforeLeave(): void {
    return;
  }

  public created(): void {
    return;
  }

  public mounted(): void {
    return;
  }

  public beforeUnmount(): void {
    return;
  }
}
